import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = { data: null, fetchedAt: 0 };
const TTL_MS = 5 * 60 * 1000;

export const LANDING_FALLBACK = {
  hero_enabled: true,
  hero_label: "Women Empowerment Community",
  hero_title_part1: "Every Woman",
  hero_title_part2: "Deserves",
  hero_title_part3: "to Thrive",
  hero_subtitle: "India ka pehla women-first community + commerce platform.",
  hero_mission_label: "Our Mission",
  hero_mission_text: "To uplift every woman — financially, emotionally, and socially.",
  hero_cta_primary: "Join Free Today",
  hero_cta_secondary: "Login",
  hero_earnings_label: "Average Monthly Earnings",
  hero_earnings_num: "₹2L+",
  hero_earnings_sub: "Top earners in our community",
  hero_floating_quote: "My family's pride.",
  hero_floating_quote_author: "Priya, Mumbai",
  features_enabled: true,
  features_pill: "Everything in one place",
  features_heading_pre: "One platform.",
  features_heading_em: "Everything",
  features_heading_post: "a woman needs to thrive.",
  features_subtitle: "From your first product sale to leading thousands of women — every tool you need, in one elegant home.",
  wallet_card_enabled: true,
};

export function useLandingSections() {
  const [config, setConfig] = useState(() => _cache.data && Date.now() - _cache.fetchedAt < TTL_MS ? _cache.data : LANDING_FALLBACK);
  const [loading, setLoading] = useState(!_cache.data);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/landing-sections");
      const merged = { ...LANDING_FALLBACK, ...r.data };
      setConfig(merged);
      _cache = { data: merged, fetchedAt: Date.now() };
    } catch (e) {
      setConfig(LANDING_FALLBACK);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!_cache.data || Date.now() - _cache.fetchedAt > TTL_MS) refresh();
    else setLoading(false);
  }, [refresh]);

  return { config, loading, refresh };
}

export function invalidateLandingSectionsCache() {
  _cache = { data: null, fetchedAt: 0 };
}
